var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtherPms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Other_PMS"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Other_PMS",
    "data-name": "Other PMS",
    clipPath: "url(#clip-Other_PMS)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038",
    transform: "translate(-703.643 -304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M919.3,418.6H896.686a1,1,0,0,0-.993.993v35.025H904v-6.468a1,1,0,0,1,.993-.993h6a1,1,0,0,1,.993.993v6.468H920.3V419.592A1,1,0,0,0,919.3,418.6Zm-13.6,21.436a.755.755,0,0,1-.752.752H901.3a.754.754,0,0,1-.752-.752v-3.647a.754.754,0,0,1,.752-.752h3.653a.755.755,0,0,1,.752.752Zm0-10.661a.755.755,0,0,1-.752.752H901.3a.754.754,0,0,1-.752-.752v-3.653a.754.754,0,0,1,.752-.752h3.653a.755.755,0,0,1,.752.752Zm9.74,10.661a.754.754,0,0,1-.752.752h-3.653a.755.755,0,0,1-.752-.752v-3.647a.755.755,0,0,1,.752-.752h3.653a.754.754,0,0,1,.752.752Zm0-10.661a.754.754,0,0,1-.752.752h-3.653a.755.755,0,0,1-.752-.752v-3.653a.755.755,0,0,1,.752-.752h3.653a.754.754,0,0,1,.752.752Z",
    transform: "translate(-155.105 -84.477)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M1048.193,488.94l-8.07-2.291v22.925h8.79v-19.68A.988.988,0,0,0,1048.193,488.94Zm-2.089,17.875a1.587,1.587,0,1,1-3.174,0v-.223a1.587,1.587,0,1,1,3.174,0Zm0-6.052a1.587,1.587,0,1,1-3.174,0v-.223a1.587,1.587,0,1,1,3.174,0Zm0-6.048a1.587,1.587,0,1,1-3.174,0v-.229a1.587,1.587,0,1,1,3.174,0Z",
    transform: "translate(-271.75 -139.436)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M898.237,674.737a1.137,1.137,0,0,0,.808-.339,1.123,1.123,0,0,0,.339-.808v-2.732H861.7v2.732h0a1.156,1.156,0,0,0,1.146,1.146Z",
    transform: "translate(-127.654 -288.209)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M800.9,670.859h-25.99v2.732a4.335,4.335,0,0,1-4.323,4.323H735.192a4.335,4.335,0,0,1-4.323-4.323v-2.732H704.88a1.24,1.24,0,0,0-1.237,1.237v4.58a5.839,5.839,0,0,0,5.819,5.823h86.856a5.839,5.839,0,0,0,5.819-5.823V672.1A1.24,1.24,0,0,0,800.9,670.859Z",
    transform: "translate(0 -288.209)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M833.473,489.9v19.68h8.789V486.659l-8.07,2.291A.985.985,0,0,0,833.473,489.9Zm2.809,4.59a1.587,1.587,0,1,1,3.174,0v.229a1.587,1.587,0,1,1-3.174,0Zm0,6.054a1.587,1.587,0,1,1,3.174,0v.223a1.587,1.587,0,1,1-3.174,0Zm0,6.052a1.587,1.587,0,1,1,3.174,0v.223a1.587,1.587,0,1,1-3.174,0Z",
    transform: "translate(-104.854 -139.444)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M835.7,333.427h-.305v.784a2.411,2.411,0,1,1-4.822,0v-.784H818.4v.784a2.411,2.411,0,1,1-4.822,0v-.784h-.305a4.22,4.22,0,0,0-4.042,3.007H752.068a3.612,3.612,0,0,0-3.605,3.605V395.16h81.251V360.552H835.7a4.219,4.219,0,0,0,4.219-4.219V337.646A4.219,4.219,0,0,0,835.7,333.427ZM823.317,386.6a2.41,2.41,0,0,1-2.4,2.4h-63.66a2.415,2.415,0,0,1-2.4-2.4V344.991a2.415,2.415,0,0,1,2.4-2.4h51.8v13.746a4.22,4.22,0,0,0,4.219,4.219h10.044ZM837.5,354.826a3.315,3.315,0,0,1-3.315,3.315H814.78a3.315,3.315,0,0,1-3.315-3.315V343.373a3.315,3.315,0,0,1,3.315-3.315H834.19a3.315,3.315,0,0,1,3.315,3.315Z",
    transform: "translate(-36.198 -15.69)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M1181.478,320.028a1.507,1.507,0,0,0,1.507-1.507v-3.014a1.507,1.507,0,0,0-3.014,0v3.014A1.507,1.507,0,0,0,1181.478,320.028Z",
    transform: "translate(-384.695)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M1093.155,320.028a1.507,1.507,0,0,0,1.507-1.507v-3.014a1.507,1.507,0,0,0-3.014,0v3.014A1.507,1.507,0,0,0,1093.155,320.028Z",
    transform: "translate(-313.363)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 5.124,
    height: 5.124,
    rx: 2.562,
    transform: "translate(777.889 326.93)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 5.124,
    height: 5.124,
    rx: 2.562,
    transform: "translate(785.725 326.93)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 5.124,
    height: 5.124,
    rx: 2.562,
    transform: "translate(793.561 326.93)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 5.124,
    height: 5.124,
    rx: 2.562,
    transform: "translate(777.889 334.766)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 5.124,
    height: 5.124,
    rx: 2.562,
    transform: "translate(785.725 334.766)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 5.124,
    height: 5.124,
    rx: 2.562,
    transform: "translate(793.561 334.766)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M806.265,416.954a3.491,3.491,0,1,0,0-2.992h-6.887a1.5,1.5,0,1,0,0,2.992Zm3.154-2.992a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,809.419,413.962Z",
    transform: "translate(-76.11 -79.121)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M803.067,444.572a.5.5,0,0,0,.5.5h1.5v-.5a.5.5,0,1,1,1,0v.5h1.5a.5.5,0,0,0,.5-.5v-1.5h-4.987Z",
    transform: "translate(-80.298 -104.245)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherPms);
export default __webpack_public_path__ + "static/media/other-PMS.08ccbc3e0771ab2c1b9f404524ed2b4b.svg";
export { ForwardRef as ReactComponent };